import React from 'react';

const BusinessTypes = () => {
  return (
    <section className="py-32 bg-surface-container-lowest border-y border-outline-variant" data-testid="industry-section">
      <div className="max-w-container-max mx-auto px-margin-desktop">
        <div className="flex flex-col lg:flex-row items-center gap-20">
          <div className="lg:w-1/2">
            <h2 className="font-display-lg text-display-lg text-primary mb-6">Perfect for Indian Small Businesses</h2>
            <p className="font-body-lg text-body-lg text-on-surface-variant mb-10 leading-relaxed">
              We've tailored every voice command and report to meet the specific challenges of Indian retail and service sectors.
            </p>
            <div className="grid grid-cols-2 gap-6">
              <div className="flex items-center gap-4 group">
                <div className="w-10 h-10 rounded-full executive-border flex items-center justify-center group-hover:bg-primary transition-colors">
                  <span className="material-symbols-outlined text-sm group-hover:text-background">storefront</span>
                </div>
                <span className="font-body-md text-body-md font-bold">Retail</span>
              </div>
              <div className="flex items-center gap-4 group">
                <div className="w-10 h-10 rounded-full executive-border flex items-center justify-center group-hover:bg-primary transition-colors">
                  <span className="material-symbols-outlined text-sm group-hover:text-background">restaurant</span>
                </div>
                <span className="font-body-md text-body-md font-bold">Restaurants</span>
              </div>
              <div className="flex items-center gap-4 group">
                <div className="w-10 h-10 rounded-full executive-border flex items-center justify-center group-hover:bg-primary transition-colors">
                  <span className="material-symbols-outlined text-sm group-hover:text-background">settings_suggest</span>
                </div>
                <span className="font-body-md text-body-md font-bold">Service Providers</span>
              </div>
              <div className="flex items-center gap-4 group">
                <div className="w-10 h-10 rounded-full executive-border flex items-center justify-center group-hover:bg-primary transition-colors">
                  <span className="material-symbols-outlined text-sm group-hover:text-background">inventory</span>
                </div>
                <span className="font-body-md text-body-md font-bold">Wholesale</span>
              </div>
            </div>
          </div>
          <div className="lg:w-1/2 w-full h-[400px] relative rounded-2xl overflow-hidden executive-border shadow-2xl">
            <img
              className="w-full h-full object-cover"
              src="https://images.unsplash.com/photo-1777356363419-1f38e0f05700?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85"
              alt="Indian retail shop interior"
              data-testid="industry-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessTypes;
